import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import { useMemo } from 'react';

const COLORS = ['#0088FE', '#00C49F'];

function CircleDiagram({ totalTasks, finishedTasks }) {
  const translateName = (name) => {
    switch(name) {
        case 'Finished':
            return 'Færdige opgaver';
        case 'Unfinished':
            return 'Ikke færdige opgaver';
        default:
            return name;
    }
}


const percentageFinished = useMemo(() => totalTasks > 0 ? (finishedTasks / totalTasks) * 100 : 0, [finishedTasks, totalTasks]);
const formattedPercentage = percentageFinished.toFixed(2);

const data = [
  { name: 'Finished', value: finishedTasks },
  { name: 'Unfinished', value: totalTasks - finishedTasks },
];
  return (
    <div>
      <h3 className='sub-header'>Resultat over kvartal opgaver</h3>
      <PieChart width={400} height={160}>
        <Pie
          data={data}
          cx={200}
          cy={75}
          innerRadius={60}
          outerRadius={80}
          fill="#8884d8"
          paddingAngle={5}
          dataKey="value"
        >
          {
            data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))
          }
        </Pie>
        <Tooltip 
          formatter={(value, name) => [value, translateName(name)]}
        />
      </PieChart>
      <div className='circle-diagram-legend'>
        {data.map((entry, index) => (
          <div key={index} className='legend-item'>
            <div className='legend-color-box' style={{
              backgroundColor: COLORS[index],
            }}></div>
            <span className='legend-text'>{translateName(entry.name)} ({entry.value})</span>

          </div>
        ))}
      </div>
      <h3 className="sub-header">{finishedTasks}/{totalTasks}Færdige opgaver</h3>
      <p className="percentage-text d-flex justify-content-center">{formattedPercentage}%</p>
    </div>
  );
}

export default CircleDiagram;
